import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Indicator, IndicatorInput } from "../indicator/indicator";
import FixedSizedLinkedList from "./FixedSizeLinkedList";
export var LowestInput =
/*#__PURE__*/
function (_IndicatorInput) {
  _inherits(LowestInput, _IndicatorInput);

  function LowestInput() {
    _classCallCheck(this, LowestInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(LowestInput).apply(this, arguments));
  }

  return LowestInput;
}(IndicatorInput);
export var Lowest =
/*#__PURE__*/
function (_Indicator) {
  _inherits(Lowest, _Indicator);

  function Lowest(input) {
    var _this;

    _classCallCheck(this, Lowest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Lowest).call(this, input));
    var values = input.values;
    var period = input.period;
    _this.result = [];
    var periodList = new FixedSizedLinkedList(period, false, true, false);
    _this.generator =
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var tick, high;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return;

            case 2:
              tick = _context.sent;

            case 3:
              if (!true) {
                _context.next = 11;
                break;
              }

              periodList.push(tick);

              if (periodList.totalPushed >= period) {
                high = periodList.periodLow;
              }

              _context.next = 8;
              return high;

            case 8:
              tick = _context.sent;
              _context.next = 3;
              break;

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })();

    _this.generator.next();

    values.forEach(function (value, index) {
      var result = _this.generator.next(value);

      if (result.value !== undefined) {
        _this.result.push(result.value);
      }
    });
    return _this;
  }

  _createClass(Lowest, [{
    key: "nextValue",
    value: function nextValue(price) {
      var result = this.generator.next(price);

      if (result.value !== undefined) {
        return result.value;
      }
    }
  }]);

  return Lowest;
}(Indicator);
Lowest.calculate = lowest;
export function lowest(input) {
  Indicator.reverseInputs(input);
  var result = new Lowest(input).result;

  if (input.reversedInput) {
    result.reverse();
  }

  Indicator.reverseInputs(input);
  return result;
}